module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-table', {
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "height": _vm.tabH
    }
  }, [_vm._l((_vm.cols), function(col) {
    return _c('el-table-column', {
      key: col.prop,
      attrs: {
        "prop": col.prop,
        "label": col.label,
        "width": col.width,
        "show-overflow-tooltip": ""
      }
    })
  }), _vm._v(" "), _c('el-table-column', {
    key: "edit",
    attrs: {
      "label": "审核",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.edit(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-edit"
        })])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    key: "del",
    attrs: {
      "label": "删除",
      "width": "80"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.del(scope.row.id)
            }
          }
        }, [_c('i', {
          staticClass: "el-icon-delete"
        })])]
      }
    }])
  })], 2)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09e34607"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/prepareProblemTable/prepareProblemTable.vue
// module id = 630
// module chunks = 4